// Module
var code = "<h2 mat-dialog-title class=\"d-flex align-items-start\"> <div>{{'Tickets' | localize }}</div> <button mat-icon-button class=\"ml-auto\" (click)=\"close()\"> <mat-icon>close</mat-icon> </button> </h2> <mat-dialog-content> <ticket-list-widget [thingId]=\"thingId\" [eventId]=\"eventId\"></ticket-list-widget> </mat-dialog-content>";
// Exports
module.exports = code;